import {Component} from "@angular/core";
import {NavController, NavParams, ViewController} from "ionic-angular";
import {CartService} from "../../app/services/cart.service";
import {Cart} from "../../app/classes/cart";
import {Product} from "../../app/classes/product";
import {DEFAULT_INGREDIENTS} from "../../app/constants/config";
import {PricePipe} from "../../app/pipes/getPrice";
import {Customer} from "../../app/classes/customer";
import {Http} from "@angular/http";
import {ProductSpecial} from "../../app/classes/product_special";

/*
 Generated class for the ProductOption page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-product-special',
  templateUrl: 'product-special.html',
  providers: [CartService, PricePipe]
})
export class ProductSpecialPage {
  public cart: Cart;
  public productIdentifier;
  public products = {};
  public variations = {};
  public product: ProductSpecial;
  public selectedSize: number;
  public selectedVariation: number;
  public defaultIngredients: any;
  public addMessage: boolean = false;
  public message: string;
  public canSubmitForm= false;
  constructor(public cartService: CartService, public http: Http, public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams) {
    this.cart = cartService.getCart();
    const originalProduct = navParams.get('product') as ProductSpecial;
    this.product = new ProductSpecial(originalProduct.getPayload(), originalProduct.getCategory());

    this.product.rules.forEach(rule => {
      this.products[rule.id] = null;
      this.variations[rule.id] = null;
    });

    this.addMessage = !!this.product.message;
    this.message = this.product.message;

  }

  exit() {
    this.viewCtrl.dismiss(this.product);
  }

  canSubmit(){
    const selectables = (this.product as any).rules.filter(f => f.type === "select_product");
    const selected = selectables.filter(rule => {
      return !!this.products[rule.id];
    });
    return selectables.length === selected.length;
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addProduct() {
    this.cart.products = this.cart.products.filter((prod) => {
      return (prod.identifier !== this.productIdentifier);
    });

    this.product.entries = JSON.parse(JSON.stringify(this.products));
    this.product.menuOptions = this.product.rules
      .filter(f => this.products[f.id])
      .reduce((cur, rule) => {
        const selectedProduct = rule.products.find(p => p.id === this.products[rule.id]);
        const selectedVariation = rule.variations.find(p => p.id === this.variations[rule.id]);
        return [...cur, {
          rule,
          selectedProduct,
          selectedVariation
        }];
      }, []);

    this.cart.addProduct(this.product, {
      added: [],
      removed: [],
      price:this.grandTotal(),
      message: this.product.message
    });

    this.viewCtrl.dismiss(this.product);
  }

  buildMessage(){
    let message = "";
    (this.product as any).rules.forEach((rule) => {
      if (this.products[rule.id]){
        const selectedProduct = rule.products.find(p => p.id === this.products[rule.id]);
        if (selectedProduct) {
          message += rule.title + ": " + selectedProduct.name + "\n";
        }
      }
    });
    return message;
  }

  grandTotal(){
    let menuPriceSet = this.product.prices[0];
    const {price, name} = menuPriceSet;

    let basePrice = price;

    (this.product as any).rules.forEach((rule) => {
      if (this.products[rule.id]){
        const selectedProduct = rule.products.find(p => p.id === this.products[rule.id]);
        if (selectedProduct) {
          if (selectedProduct.menuPrices){
            const selectedMenuPrice = selectedProduct.menuPrices.find(p => p.name === name);
            if (selectedMenuPrice){
              if (selectedMenuPrice.addPrice){
                basePrice += parseFloat(selectedMenuPrice.price);
              }
            }
          }
        }
      }
    });

    this.canSubmitForm = this.canSubmit();

    return basePrice;
  }
}



// WEBPACK FOOTER //
// ./src/pages/product-special/product-special.ts